module.exports = __webpack_public_path__ + "994f0492845364a57722c6dc59933990.woff2";